import { createContext, useContext } from 'react';

/**
 * Places in the shell's chrome that a page may render into (compact chrome,
 * 2026-10-10). Michael chose "Both rows + slimmer page headers" — "it uses too
 * much space" — so the desktop has ONE top row, and two things a page owns
 * now sit in that row or hang under it:
 *
 * - `dock`: the left side of the desktop row on a route with no area tabs
 *   (Today, Tools and Admin, an area cut to one tab). A page's own title row
 *   moves up into it, so the row still says where you are. Null wherever the
 *   area tabs fill the row, and on a phone.
 * - `subbar`: a slot under the top row in both shells — right of the sidebar
 *   on a desk, under the header on a phone — for a bar that appears on scroll
 *   (the project page's sticky bar).
 *
 * The default is no slots, so anything rendered outside the shells (unit
 * tests, MySchedulePage, the TV board) renders where it stands.
 */
export interface ShellSlots {
  dock: HTMLElement | null;
  subbar: HTMLElement | null;
}

export const ShellSlotsContext = createContext<ShellSlots>({ dock: null, subbar: null });

export const useShellSlots = () => useContext(ShellSlotsContext);
